import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryMilking = () => {
  return <CategoryBase baseEndpoint="category_milking" />;
};

export default CategoryMilking;
